import React from 'react';

const IconPlay1: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M43.48 24.4323C43.48 20.7268 33.8694 15.1235 30.4714 13.5431C24.4766 10.7552 19.898 8.95999 14.9079 9.0016C9.82023 8.93654 6.05533 10.9119 5.03326 14.3715C4.33913 16.7202 3.94838 20.5437 4.0055 24.4323C3.94838 28.3209 4.33913 32.1444 5.03326 34.4931C6.05533 37.9527 9.82023 39.928 14.9079 39.8629C19.898 39.9046 24.4766 38.1093 30.4714 35.3215C33.8694 33.7414 43.48 28.1378 43.48 24.4323Z" fill="#FA4B29" />
  </svg>
);

export default IconPlay1;
